import './ProductBasicInfoTable.less';
import React, {useState, useEffect} from 'react';
import Request from '../../../api/Request';
import ProductAttributeByProductParcel from '../../endpoints/product-attribute/ProductAttributeByProductParcel';
import ProductAttributeRelationsLoader from '../../singleton/ProductAttributeRelationsLoader';


export default function ProductBasicInfoTable({
    productCategoryId,
    productId = null,
    fixedAttributeIds = null,
    overwrittenAttributes = {},
    referenceKeys = []
}) {

    const [data, setData] = useState(ProductAttributeRelationsLoader.getData());

    const [attributeIds, setAttributeIds] = useState(fixedAttributeIds);

    useEffect(() => {
        if (productId === null) {
            setAttributeIds(fixedAttributeIds);
            return;
        }

        Request.add(new ProductAttributeByProductParcel(productId))
            .then(data => {
                setAttributeIds(data.junctions.map(t => t.product_attribute_id));
            });

    }, [productId]);

    useEffect(() => {
        if (data !== null) {
            return;
        }

        const listener = () => setData(ProductAttributeRelationsLoader.getData());

        ProductAttributeRelationsLoader.addListener(listener);

        ProductAttributeRelationsLoader.load();

        return () => ProductAttributeRelationsLoader.removeListener(listener);

    }, [data]);

    if (data === null || attributeIds === null) {
        return null;
    }


    const getBasicGroups = () => {

        const productCategory = data['product_category'].find(t => t.id === productCategoryId);

        const productClass = data['product_class'].find(t => t.id === productCategory.product_class_id);

        const classSetJunctions = data['product_class_attribute_set_junction'].filter(t => {
            return t.product_class_id === productClass.id;
        });

        classSetJunctions.sort((a, b) => a.sort_order - b.sort_order);

        const attributeGroups = classSetJunctions.reduce((result, junction) => {
            const groups = data['product_attribute_group'].filter(t => {
                return t.set_id === junction.product_attribute_set_id;
            });

            groups.sort((a, b) => a.sort_order - b.sort_order);

            result.push(...groups);

            return result;
        }, []);

        const attributes = data['product_attribute'].filter(t => {
            return attributeIds.includes(t.id);
        });

        return attributeGroups.filter(t => {
            return t.is_basic_info
                && referenceKeys.includes(t.reference_key)
                && attributes.some(attr => attr.group_id === t.id);
        });
    };

    const getAttrsByGroup = (group) => {
        if (overwrittenAttributes[group.reference_key] !== undefined) {
            return [{
                id: group.reference_key,
                name: overwrittenAttributes[group.reference_key]
            }];
        }

        const attrs = data['product_attribute']
            .filter(t => t.group_id === group.id && attributeIds.includes(t.id));

        attrs.sort((a, b) => a.sort_order - b.sort_order);

        return attrs;
    }

    return <div className="product-basic-info-table">
        <table>
            <tbody>
                {
                    getBasicGroups().map(group => {
                        return <tr key={group.id}>
                            <td className="name" width="50%">
                                {group.name}
                            </td>
                            <td className="value" width="50%">
                                {
                                    getAttrsByGroup(group).map(attr => {
                                        return <div key={attr.id}>
                                            {attr.name}
                                        </div>;
                                    })
                                }
                            </td>
                        </tr>;
                    })
                }
            </tbody>
        </table>
    </div>;
}
